import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from 'ui-component/Loadable';
import ProtectedRoute from './AdminProtectedRoutes';
import MainLayout from 'layout/MainLayout';

const Vendor = Loadable(lazy(() => import('views/pages/roads/Vendor')));
const Contractors = Loadable(lazy(() => import('views/pages/roads/Contractors')));
const ProjectOverviewPage = Loadable(lazy(() => import('views/pages/roads/ProjectOverviewPage')));
const FinancialDataPage = Loadable(lazy(() => import('views/pages/roads/FinancialData')));
const PerformanceReview = Loadable(lazy(() => import('views/pages/roads/PerformanceAnalytics')));
const ProjectTask = Loadable(lazy(() => import('views/pages/roads/ProjectTask')));
const AccountSettings = Loadable(lazy(() => import('ui-component/account-settings')));
const RoadsDashboard = Loadable(lazy(() => import('views/dashboard/Default/RoadsDashboard')));
const EnhancedProjectDashboard = Loadable(lazy(() => import('views/dashboard/Default/RegionDashboard')));
const Project = Loadable(lazy(() => import('ui-component/project')));
const ProjectReports = Loadable(lazy(() => import('ui-component/reports/project-reports')));
const AuditLogsPage = Loadable(lazy(() => import('views/pages/dashbord/utilities/AuditLog')));

// ==============================|| MAIN ROUTING ||============================== //

const RoadsRoutes = {
    path: '/civils',
    element: (
        <ProtectedRoute roles={['super_admin', 'system_admin', 'roads']}>
            <MainLayout />
        </ProtectedRoute>
    ),
    children: [
        {
            path: '/civils',
            element: <Navigate to="/civils/dashboard" replace />
        },
        {
            path: '/civils/dashboard',
            element: <RoadsDashboard />
        },
        {
            path: '/civils/analytics',
            element: <PerformanceReview />
        },
        {
            path: '/civils/dashboard/:region',
            element: <EnhancedProjectDashboard />
        },
        {
            path: '/civils/:region/:sector',
            element: <ProjectOverviewPage />
        },
        {
            path: '/civils/projects/:projectId/financial-data',
            element: <FinancialDataPage />
        },
        {
            path: '/civils/project/:projectId/reports',
            element: <ProjectReports />
        },
        {
            path: '/civils/projects/:projectId/tasks',
            element: <ProjectTask />
        },
        {
            path: '/civils/account_settings',
            element: <AccountSettings />
        },
        {
            path: '/civils/suppliers',
            element: <Vendor />
        },
        {
            path: '/civils/contractors',
            element: <Contractors />
        },
        {
            path: '/civils/project/:id',
            element: <Project />
        },
        {
            path: '/civils/audit-logs',
            element: <AuditLogsPage />
        }
    ]
};

export default RoadsRoutes;
